import { createSystem, defaultConfig } from '@chakra-ui/react';

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        primary: { value: '#2b6cb0' },
        secondary: { value: '#dd6b20' },
        purple: {
          50: { value: '#faf5ff' },
          100: { value: '#f3e8ff' },
          200: { value: '#e9d5ff' },
          300: { value: '#d8b4fe' },
          400: { value: '#c084fc' },
          500: { value: '#9333EA' },
          600: { value: '#7e22ce' },
          700: { value: '#6b21a8' },
          800: { value: '#4A1772' },
          900: { value: '#3b0764' },
        },
        textPrimary: { value: '#3F3F46' },
        textLight: { value: '#FFF' },
        textSecondary: { value: '#52525B' },
        // Auth layout semantic colors
        authText: { value: '#3F3F46' },
        authTextLight: { value: '#FFF' },
        authBackground: { value: '#FFF' },
        authBackgroundTransparent: { value: 'transparent' },
        authBorder: { value: 'rgba(88, 130, 193, 0.49)' },
      },
      fonts: {
        heading: { value: 'Inter, sans-serif' },
        body: { value: 'Inter, sans-serif' },
      },
    },
    keyframes: {
      generatingPulse: {
        '0%, 100%': { opacity: '1' },
        '50%': { opacity: '0.5' },
      },
    },
  },
});
